import { defineMessages } from 'react-intl';

export default defineMessages({
  mergePullRequestAction: {
    id: 'frontbucket.repository.pullRequest.mergePullRequest',
    description: 'Action to merge a pull request',
    defaultMessage: 'Merge',
  },
  mergeDialogTitle: {
    id: 'frontbucket.repository.pullRequest.mergePullRequestDialog',
    description: 'Title of merge dialog for a pull request',
    defaultMessage: 'Merge pull request',
  },
  mergeWorkspaceSizeLimitWarningTitle: {
    id: 'frontbucket.repository.pullRequest.mergeWorkspaceSizeLimitWarningTitle',
    description:
      'Title of merge warning for a pull request when near the workspace size limit',
    defaultMessage:
      'This workspace is getting close to the {workspaceLimit} size limit',
  },
  mergeWorkspaceSizeLimitExceededTitle: {
    id: 'frontbucket.repository.pullRequest.mergeWorkspaceSizeLimitExceededTitle',
    description:
      'Title of merge warning for a pull request when over the workspace size limit',
    defaultMessage: 'This workspace is over the {workspaceLimit} size limit',
  },
  mergeWorkspaceSizeLimitWarningDescription: {
    id: 'frontbucket.repository.pullRequest.mergeWorkspaceSizeLimitWarningDescription',
    description:
      'Description of merge warning for a pull request when near the workspace size limit',
    defaultMessage:
      'If this workspace reaches the {workspaceLimit} size limit, you will not be able to push or merge new commits to any repositories in this workspace. Either reduce the size of this workspace, or upgrade to a Standard or Premium plan to increase the size of this workspace.',
  },
  mergeWorkspaceSizeLimitExceededDescription: {
    id: 'frontbucket.repository.pullRequest.mergeWorkspaceSizeLimitExceededDescription',
    description:
      'Description of merge warning for a pull request when over the workspace size limit',
    defaultMessage:
      'Because this workspace is over the {workspaceLimit} size limit, you cannot push any new commits to any repositories in this workspace. Either reduce the size of this workspace, or upgrade to a Standard or Premium plan to increase the size of this workspace.',
  },
  mergeReduceRepoSizeLink: {
    id: 'frontbucket.repository.pullRequest.mergeReduceRepoSizeLink',
    description: 'Link to reduce repository size',
    defaultMessage: 'Reduce repository size',
  },
  mergeUpgradeToPaidPlanLink: {
    id: 'frontbucket.repository.pullRequest.mergeUpgradeToPaidPlanLink',
    description: 'Link to upgrade to a paid plan',
    defaultMessage: 'Upgrade to a paid plan',
  },
  mergeWarningDialogTitle: {
    id: 'frontbucket.repository.pullRequest.mergeWarningDialogTitle',
    description: 'Title of merge warning for a pull request',
    defaultMessage: 'Merge checks not enforced',
  },
  mergeWarningDialogDescription: {
    id: 'frontbucket.repository.pullRequest.mergeWarningDialogDescription',
    description: 'Description of merge warning for a pull request',
    defaultMessage:
      'If your merge checks are failing, your pull request will still be merged as long as the build is successful.',
  },
  mergeWarningMergeAnywayButton: {
    id: 'frontbucket.repository.pullRequest.mergeWarningMergeAnywayButton',
    description: 'Action to merge a pull request',
    defaultMessage: 'Merge anyway',
  },
  mergeDialogCommitMessageLabel: {
    id: 'frontbucket.repository.pullRequest.mergeDialogCommitMessageLabel',
    description: 'Label the merge dialog commit message text area',
    defaultMessage: 'Commit message',
  },
  mergeDialogMergeStrategyLabel: {
    id: 'frontbucket.repository.pullRequest.mergeDialogMergeStrategyLabel',
    description: 'Label the merge strategy selecter',
    defaultMessage: 'Merge strategy',
  },
  sourceBranch: {
    id: 'frontbucket.repository.pullRequest.mergeDialogSourceBranch',
    description: 'Label the source branch',
    defaultMessage: 'Source',
  },
  destinationBranch: {
    id: 'frontbucket.repository.pullRequest.mergeDialogDestinationBranch',
    description: 'Label the destination branch',
    defaultMessage: 'Destination',
  },
  closeSourceBranch: {
    id: 'frontbucket.repository.pullRequest.closeSourceBranch',
    description: 'Label for close source branch checkbox',
    defaultMessage: 'Close source branch',
  },
  closeSourceBranchAndRetargetStackedPullRequests: {
    id: 'frontbucket.repository.pullRequest.closeSourceBranchAndRetargetStackedPullRequests',
    description:
      'Label for close source branch checkbox when there is at least one stacked pull request',
    defaultMessage: 'Close source branch and retarget {stackedPullRequests}',
  },
  stackedPullRequestsLink: {
    id: 'frontbucket.repository.pullRequest.stackedPullRequestsLink',
    description: 'Link to the list of stacked pull requests',
    defaultMessage:
      '{count, plural, one {{count} affected pull request} other {{count} affected pull requests}}',
  },
  mergedInLabel: {
    id: 'frontbucket.respository.pullRequest.mergedInLabel',
    description:
      'Label for the merged-in section of the default commit message',
    defaultMessage: 'Merged in',
  },
  approvedByLabel: {
    id: 'frontbucket.respository.pullRequest.approvedByLabel',
    description:
      'Label for the approved-by section of the default commit message',
    defaultMessage: 'Approved-by:',
  },
  pullRequestLabel: {
    id: 'frontbucket.respository.pullRequest.pullRequestLabel',
    description:
      'Label for the pull request section of the default commit message',
    defaultMessage: 'pull request',
  },
  createPendingMergeAction: {
    id: 'frontbucket.repository.pullRequest.createPendingMergeAction',
    description: 'Action to automically merge a pull request when possible',
    defaultMessage: 'Merge when builds pass',
  },
  cancelPendingMergeHeading: {
    id: 'frontbucket.respository.pullRequest.cancelPendingMergeTitle',
    description: 'Heading for cancel a pending merge option',
    defaultMessage: `You’ve got a pending merge`,
  },
  cancelPendingMergeDescription: {
    id: 'frontbucket.respository.pullRequest.cancelPendingMergeDescription',
    description:
      'Description for notice that a merge is pending and can be cancelled',
    defaultMessage: `We'll merge this pull request automatically if all builds are successful.`,
  },
  cancelPendingMergeAction: {
    id: 'frontbucket.repository.pullRequest.cancelPendingMergeAction',
    description: 'Action to cancel a pending merge',
    defaultMessage: 'Cancel merge',
  },
  mergeWarningLinkText: {
    id: 'frontbucket.repository.pullRequest.mergeWarningLinkText',
    description: 'Learn more link text',
    defaultMessage: 'Learn more',
  },
  mergeWarningTooltip: {
    id: 'frontbucket.repository.pullRequest.mergeWarningTooltip',
    description: 'Text of tooltip',
    defaultMessage: 'Must pass merge checks before merging',
  },
  mergeIssueTransitionWarningTooltip: {
    id: 'frontbucket.repository.pullRequest.mergeIssueTransitionWarningTooltip',
    description: 'Text of tooltip',
    defaultMessage:
      'Must uncheck issue transitions or select a transition before merging',
  },
  mergeIssueConflictsTooltip: {
    id: 'frontbucket.repository.pullRequest.mergeIssueConflictsTooltip',
    description: 'Text of tooltip',
    defaultMessage: 'You will need to resolve conflicts to be able to merge.',
  },
  otherSourceBranchPullRequests: {
    id: 'frontbucket.repository.pullRequest.otherSourceBranchPullRequestsOpen',
    description: 'Label for disabled close source branch checkbox tooltip',
    defaultMessage:
      "The source branch can't be deleted, it has other open pull requests",
  },
  pendingReviewersTitle: {
    id: 'frontbucket.repository.pullRequest.pendingReviewersSectionMsg.title',
    description: 'Title for pending reviews info panel',
    defaultMessage: 'Pending reviews',
  },
  pendingReviewersSubtitle: {
    id: 'frontbucket.repository.pullRequest.pendingReviewersSectionMsg.subtitle',
    description: 'Subtitle for pending reviews info panel',
    defaultMessage: `Your pull request is ready to merge; however, there are reviews still in progress from the following reviewers:`,
  },
  invalidMergeMessageSizeError: {
    id: 'frontbucket.repository.pullRequest.mergeMessageSizeError',
    description:
      'Error message displayed when the merge commit message size exceeds the limit',
    defaultMessage: `The merge commit message exceeds the { maxSizeInKiB } KiB size limit.`,
  },
});
